$(document).ready(function() {
    if (sessionStorage.measurement) {
        var savedUnit = sessionStorage.getItem('measurement');
    } else {
        var savedUnit = 'metric';
    }
    if (sessionStorage.gender) {
        var savedUnit_mf = sessionStorage.getItem('gender');
    } else {
        var savedUnit_mf = 'male';
    }
    if (sessionStorage.use) {
        var savedUnit_use = sessionStorage.getItem('use');
    } else {
        var savedUnit_use = 'changing';
    }
    // show dress size row or waist row
    if (savedUnit_mf == 'female') {
      // $('tr.waist-size').hide();
      $('tr.waist-size').show();
      $('tr.dress-size').show();
    } else {
      $('tr.dress-size').show();
      $('tr.waist-size').show();
    }
        // show dress size row or waist row
    if (savedUnit_use == 'changing') {
      $('table.snugfit').show();
      $('table.loosefit').show();
    } else {
      $('table.loosefit').show();
      $('table.snugfit').show();
    }
    // setting the current unit on load just to have separate variable
    var currentUnit = savedUnit;
    var currentUnit_mf = savedUnit_mf;
    var currentUnit_use = savedUnit_use;
//     console.log('page load set measurement to ' + currentUnit);
//     console.log('page load set gender ' + currentUnit_mf);
    $('.unitSwitch a[data-unit-type="' + savedUnit + '"]').addClass('active');
    $('.unitSwitch_mf a[data-unit-type="' + savedUnit_mf + '"]').addClass('active');
    $('.unitSwitch_use a[data-unit-type="' + savedUnit_use + '"]').addClass('active');
    // For all measurements with metric data values
    $('[data-metric]').each(function() {
        var $this = $(this);
        // if the default data unit value is undefined, save the original text as the value
        if ($this.data('standard') === undefined) {
            $this.data('standard', $this.text());
        }
        // If the shown text doesn't match the selected unit data value, change it.
        if ($this.text !== $this.data(savedUnit)) {
            $this.text($this.data(savedUnit));
        }
    });
    // metric imperial
    $('.unitSwitch a').on("click", function(event) {
        event.preventDefault();
        // set the site-units cookie to the value of the clicked link's data-sitewide-units (and currentUnit var as well)
        var selectedUnit = $(this).data('unit-type');
        currentUnit = selectedUnit;
        sessionStorage.setItem('measurement', currentUnit);
//         console.log('switch changed currentUnit to ' + currentUnit);
        //remove active state from all buttons, add back to selected
        $('.unitSwitch a').removeClass('active');
        $('.unitSwitch a[data-unit-type="' + selectedUnit + '"]').addClass('active');
        // For all measurements with metric data values
        $('[data-metric]').each(function() {
            var $this = $(this);
            // if the default data unit value is undefined, save the original text as the value
            if ($this.data('standard') === undefined) {
                $this.data('standard', $this.text());
            }
            // If the shown text doesn't match the selected unit data value, change it.
            if ($this.text !== $this.data(selectedUnit)) {
                $this.text($this.data(selectedUnit));
                $this.removeClass('flash');
                setTimeout(function() {
                    $this.addClass('flash');
                }, 1);
            }
        });
    });
    // male female
    $('.unitSwitch_mf a').on("click", function(event) {
        event.preventDefault();
        // set the site-units cookie to the value of the clicked link's data-sitewide-units (and currentUnit var as well)
        var selectedUnit_mf = $(this).data('unit-type');
        currentUnit_mf = selectedUnit_mf;
        sessionStorage.setItem('gender', currentUnit_mf);
        if (currentUnit_mf == 'female'){
          $('tr.waist-size').hide();
          $('tr.dress-size').show();
        } else {
          $('tr.dress-size').hide();
          $('tr.waist-size').show();
        }
//         console.log('switch changed currentUnit to ' + currentUnit_mf);
        //remove active state from all buttons, add back to selected
        $('.unitSwitch_mf a').removeClass('active');
        $('.unitSwitch_mf a[data-unit-type="' + selectedUnit_mf + '"]').addClass('active');
    });
    // dryrobe USE
    $('.unitSwitch_use a').on("click", function(event) {
        event.preventDefault();
        // set the site-units cookie to the value of the clicked link's data-sitewide-units (and currentUnit var as well)
        var selectedUnit_use = $(this).data('unit-type');
        currentUnit_use = selectedUnit_use;
        sessionStorage.setItem('use', currentUnit_use);
        if (currentUnit_use == 'changing'){
          $('table.snugfit').hide();
          $('table.loosefit').show();
        } else {
          $('table.loosefit').hide();
          $('table.snugfit').show();
        }
//         console.log('switch changed currentUnit to ' + currentUnit_mf);
        //remove active state from all buttons, add back to selected
        $('.unitSwitch_use a').removeClass('active');
        $('.unitSwitch_use a[data-unit-type="' + selectedUnit_use + '"]').addClass('active');
    });
});